import { render, staticRenderFns } from "./HelpDeskCardList.vue?vue&type=template&id=e5e79680"
import script from "./HelpDeskCardList.vue?vue&type=script&lang=js"
export * from "./HelpDeskCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports